!function(){"use strict";angular.module("scApp.detalleCredito",[])}();